// src/lib/ltiClaims.js
export function getLtiToken() {
  return localStorage.getItem('lti') || null;
}

export function clearLtiToken() {
  localStorage.removeItem('lti');
}

export function getLtiClaims() {
  const token = getLtiToken();
  if (!token) return null;
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isLtiSession() {
  return !!getLtiToken();
}
